import { useTranslation } from 'react-i18next';
import { useGetRequiredRule } from '@/hooks';
import { BannersFields } from '../helpers';

export const useBannerFormValidationRules = () => {
  const { t } = useTranslation(['validations']);

  const requiredRule = useGetRequiredRule({ t });
  return {
    [BannersFields.END_DATE]: [requiredRule],
    [BannersFields.START_DATE]: [requiredRule],
    [BannersFields.LOCALE]: [requiredRule],
    [BannersFields.WEB_MEDIA]: [requiredRule],
    [BannersFields.ACTIVE]: [requiredRule],
    [BannersFields.MOBILE_MEDIA]: [requiredRule],
  };
};
